import { PostCard } from '@/pages/timeline/components';
import { useEffect } from 'react';
import { TimelinePost } from '@/types/post';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { type TimelineFilters } from '@/pages/timeline/components';
import { TimelineProvider, useTimeline } from '@/contexts/timeline';
import { useAuth } from '@/contexts/auth';

function TimelineRejectedContent() {
  const { posts, isLoading, isFetchingMore, offset } = useTimeline();

  const sortedPosts = posts

  const leftColumnPosts = sortedPosts.filter((_, index) => index % 2 === 0);
  const rightColumnPosts = sortedPosts.filter((_, index) => index % 2 === 1);

  return (
    <div className="space-y-4">
      {isLoading && offset === 0 && (
        <div className="flex items-center justify-center py-6 text-gray-600">
          Carregando...
        </div>
      )}
      {!isLoading && sortedPosts.length === 0 && (
        <div className="flex items-center justify-center py-6 text-gray-600">
          Nenhum conteúdo encontrado.
        </div>
      )}
      {!isLoading || offset > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-8">
          <div className="space-y-4">
            {leftColumnPosts.map((post: TimelinePost) => (
              <PostCard 
                key={post.id} 
                post={post}
                status="rejected"
              />
            ))}
          </div>
          <div className="space-y-4">
            {rightColumnPosts.map((post: TimelinePost) => (
              <PostCard 
                key={post.id} 
                post={post}
                status="rejected"
              />
            ))}
          </div>
        </div>
      ) : null}
      {isFetchingMore && (
        <div className="flex items-center justify-center py-6 text-gray-600">
          Carregando...
        </div>
      )}
    </div>
  );
}

export default function TimelineRejectedPage() {
  const { filters } = useOutletContext<{ filters?: TimelineFilters }>();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.email !== 'root@live.com') {
      navigate('/app/timeline/curated', { replace: true });
    }
  }, [user, navigate]);

  if (user && user.email !== 'root@live.com') {
    return null;
  }

  return (
    <TimelineProvider 
      type="REJECTED"
      filters={filters}
    >
      <TimelineRejectedContent />
    </TimelineProvider>
  );
}
